export type FocusPhase = 'idle' | 'entering' | 'focused' | 'exiting';

export interface FocusView {
  id: string | null;
  phase: FocusPhase;
}

export const IDLE_FOCUS: FocusView = { id: null, phase: 'idle' };

const focusTargetOf = (view: FocusView) =>
  view.phase === 'entering' || view.phase === 'focused' ? view.id : null;

export const nextFocusView = (
  view: FocusView,
  target: string | null,
  reducedMotion: boolean
): FocusView => {
  if (focusTargetOf(view) === target) return view;
  if (target === null) {
    return reducedMotion || !view.id
      ? IDLE_FOCUS
      : { id: view.id, phase: 'exiting' };
  }
  if (reducedMotion) return { id: target, phase: 'focused' };
  if (view.phase === 'entering' || view.phase === 'focused') {
    return { id: target, phase: 'focused' };
  }
  return { id: target, phase: 'entering' };
};

export const settleFocusView = (view: FocusView): FocusView => {
  if (view.phase === 'entering') return { ...view, phase: 'focused' };
  if (view.phase === 'exiting') return IDLE_FOCUS;
  return view;
};

export const settleFocusViewFor = (
  view: FocusView,
  phase: FocusPhase
): FocusView => (view.phase === phase ? settleFocusView(view) : view);

export const isFocusCrossfading = (view: FocusView) =>
  view.phase === 'entering' || view.phase === 'exiting';

export const shouldShowPlaceholder = (view: FocusView, dashletId: string) =>
  view.phase !== 'idle' && view.id !== null && dashletId !== view.id;

export const shouldShowLive = (view: FocusView, dashletId: string) =>
  !shouldShowPlaceholder(view, dashletId) || isFocusCrossfading(view);
